import { useJobillaOrgId } from '@/hooks'
import { useCampaignRegenerate, useCampaignScrapeOnExistingCampaign } from '@jobilla/nexus-sdk'
import { useCallback } from 'react'
import { ConformedBranding, useRegenerateCallback } from '../../ui'

export function useNewEditorRegenerate(campaignId: string) {
	const jobillaOrgId = useJobillaOrgId()

	const { mutateAsync: generateFromScanMutation } = useCampaignScrapeOnExistingCampaign({
		mutationKey: ['regenerate-from-scan', campaignId],
	})

	const { mutateAsync: generateFromManualMutation } = useCampaignRegenerate({
		mutationKey: ['regenerate-from-manual', campaignId],
	})

	const handleRegenerateFromUrl = useCallback(async (url: string, brand: ConformedBranding) => {
		await generateFromScanMutation({
			campaign: campaignId,
			data: {
				organisationId: jobillaOrgId,
				url,
				branding: {
					id: brand.id,
					logoId: brand.logoId,
					website: brand.website,
					toneOfVoice: brand.toneOfVoice,
					visualGuidance: brand.visualGuidance,
					fonts: {
						body: brand.bodyFont,
						title: brand.titleFont,
					},
					background: brand.background,
					foreground: brand.foreground,
					accentBackground: brand.accentBackground,
					accentForeground: brand.accentForeground,
					generateKeyImage: brand.generateKeyImage,
				},
			},
		})
		// Force reload after URL regeneration to avoid stale data issues
		window.location.reload()
	}, [generateFromScanMutation, campaignId, jobillaOrgId])

	const handleRegenerateFromManual = useCallback(async (
		data: { title: string; location: string; language: string; requirements: string },
		brand: ConformedBranding,
	) => {
		await generateFromManualMutation({
			campaign: campaignId,
			data: {
				title: data.title,
				location: data.location,
				language: data.language,
				requirements: data.requirements,
				branding: {
					id: brand.id,
					logoId: brand.logoId,
					website: brand.website,
					toneOfVoice: brand.toneOfVoice,
					visualGuidance: brand.visualGuidance,
					fonts: {
						body: brand.bodyFont,
						title: brand.titleFont,
					},
					background: brand.background,
					foreground: brand.foreground,
					accentBackground: brand.accentBackground,
					accentForeground: brand.accentForeground,
					generateKeyImage: brand.generateKeyImage,
				},
			},
		})
		// Force reload after manual regeneration to avoid stale data issues
		window.location.reload()
	}, [generateFromManualMutation, campaignId])

	useRegenerateCallback({
		onRegenerateFromUrl: handleRegenerateFromUrl,
		onRegenerateFromManual: handleRegenerateFromManual,
	})

	return {}
}
